export default __webpack_public_path__ + "static/media/EM0770.34I-21941_-14977_0.49af82f7.jpg";